import { render } from "./CZHistoricConsumptionCo2EB.vue?vue&type=template&id=657b1aba&scoped=true&ts=true"
import script from "./CZHistoricConsumptionCo2EB.vue?vue&type=script&lang=ts"
export * from "./CZHistoricConsumptionCo2EB.vue?vue&type=script&lang=ts"

import "./CZHistoricConsumptionCo2EB.vue?vue&type=style&index=0&id=657b1aba&scoped=true&lang=css"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657b1aba"]])

export default __exports__